import { TextField } from '@ipfabric/ui-components/TextField/TextField';
import { memo } from 'react';
import type { WrappedFieldProps } from 'redux-form';

type ReduxFormTextFieldProps = WrappedFieldProps & {
  label?: string;
  validationMessages?: {
    [key: string]: string;
  };
  type?: 'text' | 'password';
};

export const ReduxFormTextField = memo(
  ({
    type = 'text',
    label,
    meta,
    validationMessages,
    input,
  }: ReduxFormTextFieldProps) => {
    const error =
      meta.touched && meta.error
        ? (validationMessages?.[meta.error] ??
          (typeof meta.error === 'string' ? meta.error : 'Error'))
        : undefined;

    return <TextField {...input} type={type} label={label} error={error} />;
  },
);
